export default {
  form: [
    {
      id: 1,
      group: "sections",
      type: "products",
      title: "",
      description: {
        nl: "<p></p>",
        en: "<p></p>"
      },
      css: "custom css",
      products: [],
      defaultProducts: []
    }
  ],
  previewForm: []
};
